export enum StatisticTab {
    GENERAL = 'general',
    PORTS = 'ports',
    PRODUCTS = 'products',
    PRODUCT_GROUPS = 'productGroups',
    VESSELS = 'vessels',
    SUPPLIERS = 'suppliers',
    CUSTOMERS = 'customers',
}
